module.exports = __webpack_public_path__ + "static/media/DANGER_END_FAST.1fa53baa.mp3";